/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb = FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions);
    }

    return {};
}

